import { api, handleApiError } from '@/lib/api';
import type {
  PlacesSearchResponse,
  VenueListResponse,
  CreateVenueFromPlaceDTO,
  Venue,
} from '../types';

export const venueApi = {
  searchPlaces: async (query: string): Promise<PlacesSearchResponse> => {
    try {
      const params = new URLSearchParams({ query });
      return await api.get<PlacesSearchResponse>(`/admin/venues/search-places?${params}`);
    } catch (error) {
      handleApiError(error, { operation: 'search_places', query });
      throw error;
    }
  },

  getPlaceDetails: async (placeId: string): Promise<any> => {
    try {
      return await api.get(`/admin/venues/place-details/${placeId}`);
    } catch (error) {
      handleApiError(error, { operation: 'get_place_details', placeId });
      throw error;
    }
  },

  list: async (query?: string): Promise<VenueListResponse> => {
    try {
      const url = query 
        ? `/admin/venues?${new URLSearchParams({ query }).toString()}`
        : '/admin/venues';
      return await api.get<VenueListResponse>(url);
    } catch (error) {
      handleApiError(error, { operation: 'list_venues', query });
      throw error;
    }
  },

  createFromPlace: async (data: CreateVenueFromPlaceDTO): Promise<Venue> => {
    try {
      return await api.post<Venue>('/admin/venues/create-from-place', data);
    } catch (error) {
      handleApiError(error, { operation: 'create_venue_from_place', data });
      throw error;
    }
  },

  delete: async (venueId: number): Promise<void> => {
    try {
      await api.delete(`/admin/venues/${venueId}`);
    } catch (error) {
      handleApiError(error, { operation: 'delete_venue', venueId });
      throw error;
    }
  },
};